export default __webpack_public_path__ + "static/media/2019-4.a7528238.jpeg";